export const flowAndPauseDetails = [
  { label: 'מתי', value: 'שבת | 24.10', note: '09:00–13:00' },
  { label: 'איפה', value: "ביץ' קלאב מעגן עדן", note: 'הכנרת' },
  { label: 'מחיר', value: '₪450 למשתתפת', note: 'בוקר שלם של ארבע שעות' },
  { label: 'מקומות', value: 'מספר מוגבל', note: 'קבוצה קטנה ואינטימית' },
]

export const flowAndPauseProgram = [
  {
    title: 'נחיתה על החוף',
    description: 'מתכנסות מול המים, נושמות את הבוקר ומשאירות את השבוע מאחור.',
  },
  {
    title: 'צילום מים, תנועה והשתקפויות',
    description:
      'עם טלי – איך לראות ולתפוס אור, תנועה והשתקפויות. אפשר גם בטלפון.',
  },
  {
    title: 'יין ונשנושים',
    description: 'הפסקה מפנקת על החוף – כוס יין, נשנושים טעימים וזמן לשיחה.',
  },
  {
    title: 'נשימה מודעת',
    description: 'עם עדי – עצירה, האטה והכנה של הגוף והראש למפגש עם הקור.',
  },
  {
    title: 'טבילה באמבט קרח',
    description: 'כניסה מודרכת לקרח בליווי צמוד, בקצב של כל אחת.',
  },
  {
    title: 'שיתוף ותמונות',
    description: 'מסתכלות יחד על מה שצילמנו – ועל מה שהרגשנו.',
  },
]

export const flowAndPauseHosts = [
  {
    name: 'טלי הראל אבן',
    role: 'צלמת',
    bio: 'מלמדת להתבונן אחרת – על המים, על האור ועל עצמנו – דרך העדשה.',
    image:
      'https://cdn.magicpatterns.com/uploads/3j9jjR89JZ2eFzNUZYYMFM/tali-portrait.webp',
    alt: 'טלי הראל אבן יושבת בכורסה ומחזיקה מצלמה',
  },
  {
    name: 'עדי שמעוני',
    role: 'מדריכת חשיפה לקור ונשימה מודעת',
    bio: 'חותרת סאפ מקצועית. מדריכה ומלווה אנשים בתהליכים של פיתוח חוסן, עוצמה והתמודדות באמצעות תנועה ונשימה.',
    image:
      'https://cdn.magicpatterns.com/uploads/oA2BS8qcd7MXHEKX1PSjGm/adi-ice-bath.webp',
    alt: 'עדי מלווה משתתפת באמבט קרח',
  },
]

export const flowAndPauseGallery = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hPb1DyryryoNUJ8DyTTqZa/PHOTO-2026-09-30-08-57-45_(1).jpg',
    alt: 'עדי ומשתתפת רגע לפני הכניסה לאמבט הקרח',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uv5WXr3FedxEyYgcG12z97/PHOTO-2026-09-30-08-57-45.jpg',
    alt: 'עדי כורעת ליד אמבט הקרח ומלווה משתתפת',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ghRVFNM1XyrUC8dYKMmBDD/PHOTO-2026-09-30-08-57-45_(2).jpg',
    alt: 'עדי תומכת במשתתפת בתוך הקרח',
  },
]
